"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutStatus = exports.AuthorizationStatusResult = exports.WORKFLOW_CANCEL_REASON = void 0;
var WORKFLOW_CANCEL_REASON;
(function (WORKFLOW_CANCEL_REASON) {
    WORKFLOW_CANCEL_REASON["USER_CANCEL"] = "USER_CANCEL";
    WORKFLOW_CANCEL_REASON["API_ERROR"] = "API_ERROR";
    WORKFLOW_CANCEL_REASON["EXCEED_MAXIMUM_RETRY"] = "EXCEED_MAXIMUM_RETRY";
    WORKFLOW_CANCEL_REASON["USER_NO_ACTIVE_HARD_TOKEN"] = "USER_NO_ACTIVE_HARD_TOKEN";
    WORKFLOW_CANCEL_REASON["USER_NO_ACTIVE_SOFT_TOKEN"] = "USER_NO_ACTIVE_SOFT_TOKEN";
    WORKFLOW_CANCEL_REASON["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(WORKFLOW_CANCEL_REASON = exports.WORKFLOW_CANCEL_REASON || (exports.WORKFLOW_CANCEL_REASON = {}));
var AuthorizationStatusResult;
(function (AuthorizationStatusResult) {
    AuthorizationStatusResult["PENDING"] = "PENDING";
    AuthorizationStatusResult["SUCCESS"] = "SUCCESS";
    AuthorizationStatusResult["FAILED"] = "FAILED";
    AuthorizationStatusResult["MAX_TRY_COUNTS"] = "MAX_TRY_COUNTS";
})(AuthorizationStatusResult = exports.AuthorizationStatusResult || (exports.AuthorizationStatusResult = {}));
var LayoutStatus;
(function (LayoutStatus) {
    LayoutStatus["NULL"] = "NULL";
    LayoutStatus["VERIFY_SUCCESS"] = "VERIFY_SUCCESS";
    LayoutStatus["VALIDATE_SUCCESS"] = "VALIDATE_SUCCESS";
    LayoutStatus["INVALID_USER"] = "INVALID_USER";
    LayoutStatus["TRANSACTION_SIGNING_OTP"] = "TRANSACTION_SIGNING_OTP";
    LayoutStatus["TRANSACTION_SIGNING_ERROR"] = "TRANSACTION_SIGNING_ERROR";
    LayoutStatus["TRANSACTION_SIGNING_ONETOKEN"] = "TRANSACTION_SIGNING_ONETOKEN";
    LayoutStatus["OTP_RESENT_SUCCESS"] = "OTP_RESENT_SUCCESS";
    LayoutStatus["INVALID_OTP"] = "INVALID_OTP";
    LayoutStatus["ONE_TOKEN_WITH_FOOTER"] = "ONE_TOKEN_WITH_FOOTER";
    LayoutStatus["LOST_OR_CHANGED"] = "LOST_OR_CHANGED";
})(LayoutStatus = exports.LayoutStatus || (exports.LayoutStatus = {}));
